import { z } from "zod"

const EcryptMetadataSchema = z.record(z.string(), z.union([z.string(), z.number(), z.boolean(), z.null()]))

export const EcryptTransactionWebhookSchema = z
	.looseObject({
		event: z.literal("transaction"),
		action: z.enum(["approved", "declined"]),
		data: z
			.looseObject({
				Order: z.object({
					MetaData: EcryptMetadataSchema,
				}),
				Transaction: z.object({
					TransactionId: z.string(),
					RequestId: z.string(),
					Amount: z.unknown().optional(),
				}),
			}),
	})
	.meta({ id: "EcryptTransactionWebhook" })

export type EcryptTransactionWebhook = z.infer<typeof EcryptTransactionWebhookSchema>

export const EcryptWebhookResponseSchema = z
	.object({
		ok: z.boolean(),
		reason: z.string().optional(),
		deduped: z.boolean().optional(),
		ignored: z.string().optional(),
	})
	.meta({ id: "EcryptWebhookResponse" })

export type EcryptWebhookResponse = z.infer<typeof EcryptWebhookResponseSchema>
